// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31Swq","title":"styles_title__tL8m2"};